import { useModules } from './../utils/modules';
import { isRouteAllowedForUser } from '../router/access/urlAccessManager';

// Order and labels of the admin left nav. Visibility comes from the same
// route rules UrlAccessGate enforces, so the menu and direct URL access
// cannot drift apart.
const ADMIN_MENU_ITEMS = [
  { name: "Profile Settings", path: "/orgprofile", dataTest: "Profile Settings" },
  { name: "Relationships", path: "/relationships", dataTest: "Relationships" },
  { name: "Users", path: "/users", dataTest: "Users" },
  { name: "Organization Access", path: "/orgaccess", dataTest: "Organization Access" },
  { name: "Rules", path: "/ruleengine", dataTest: "Rules" },
  { name: "Parties", path: "/parties", dataTest: "Parties" },
  { name: "Inbox", path: "/inboxadmin", dataTest: "Inbox" },
  { name: "Mercury", path: "/mercuryadmin", dataTest: "Mercury" },
  { name: "Communication", path: "/managecomm", dataTest: "Communication" },
  { name: "Letters", path: "/letteradmin", dataTest: "Letters" },
  { name: "Settings", path: "/settings", dataTest: "Settings" },
];

export const getAdminMenuList = (uview) => {
  if (!uview) return [];
  return ADMIN_MENU_ITEMS
    .filter(({ path }) => isRouteAllowedForUser(path, uview))
    .map((item) => ({ ...item }));
};

export const ActivityResolution = {
    Assigned: 'Assigned',
    Open: 'Open',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    RejectedClosed: 'RejectedClosed',
    ClosedMidTerm: 'ClosedMidTerm',
    ReAssigned: 'ReAssigned',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Closed: 'Closed',
    ReOpened: 'ReOpened',
    ReAssignedClosed: 'ReAssignedClosed',
    UnAssigned: 'UnAssigned',
};

export const getActivityActions = (activityData, userOrgId, userView, isCurrentOwnerBlocked, isCurrentAssigneeBlocked,editPermissions) => {
    const {
        resolution,
        assigneeOrgId,
        ownerOrgId,
        activityAssigneeId,
        activityTemplateType = null
    } = activityData;

    const { canEditActivityTemplate, isDefaultTemplate } = editPermissions;

    const actionList = [];

    if (userOrgId !== assigneeOrgId && userOrgId !== ownerOrgId) {
        return actionList;
    }

    const isAssignee = userOrgId === assigneeOrgId;
    const isOwner = userOrgId === ownerOrgId;
    const isSameOrganisation = (assigneeOrgId === ownerOrgId) && (isAssignee || isOwner);

    // Block Case
    if (isCurrentOwnerBlocked || isCurrentAssigneeBlocked) {
        if (!isSameOrganisation) {
            if (isCurrentAssigneeBlocked && isAssignee) {
                if (userView.canReassignActivity) {
                    actionList.push(ActivityActions.ReassignIntraOrganization);
                }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) {
                    actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                } else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) {
                    actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption);
                } else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity) {
                    actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                }
                if (userView.canAddPersonalNotesActivity) {
                    actionList.push(ActivityActions.AddPersonalNote);
                }
                return actionList;
            }
        }
    }

    switch (resolution) {
        case ActivityResolution.Assigned:
        case ActivityResolution.Open:
            if (isSameOrganisation) {
                if (userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivateNoteWithInProgressOption : ActivityActions.AddPrivateNoteWithNoInProgressOption);
                else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
            } else {
                if (isOwner) {
                    if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                    if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                } else if (isAssignee) {
                    if (userView.canAcceptRejectActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.AcceptPublic : ActivityActions.AcceptPrivate); }
                    if (userView.canAcceptRejectActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.RejectPublic : ActivityActions.RejectPrivate); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                }
            }
            break;

        case ActivityResolution.Accepted:
            if (isOwner) {
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                    actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
            } else if (isAssignee) {
                if (userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivateNoteWithInProgressOption : ActivityActions.AddPrivateNoteWithNoInProgressOption);
                else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canCompleteActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CompletePublic : ActivityActions.CompletePrivate); }
            }
            break;

        case ActivityResolution.Closed:
            if (isSameOrganisation) {
                if (userView.canReopenActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ReOpenPublic : ActivityActions.ReOpenPrivate); }
                if (userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                else if (userView.canAddPublicNotesActivity && !userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
            } else {
                if (isOwner && userView.canReopenActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ReOpenPublic : ActivityActions.ReOpenPrivate); }
                if (userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                else if (userView.canAddPublicNotesActivity && !userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
            }
            break;

        case ActivityResolution.ClosedMidTerm:
            if (isSameOrganisation && userView.canReopenActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ReOpenPublic : ActivityActions.ReOpenPrivate); }
            else if (isOwner && userView.canReopenActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ReOpenPublic : ActivityActions.ReOpenPrivate); }
            if (userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
            if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
            break;

        case ActivityResolution.Completed:
            if (isSameOrganisation) {
                if (userView.canCloseActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ClosePublic : ActivityActions.ClosePrivate); }
                if (userView.canReopenActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ReOpenPublic : ActivityActions.ReOpenPrivate); }
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                    actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
            } else {
                if (isOwner) {
                    if (userView.canCloseActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ClosePublic : ActivityActions.ClosePrivate); }
                    if (userView.canReopenActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.ReOpenPublic : ActivityActions.ReOpenPrivate); }
                    if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                } else if (isAssignee) {
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                }
            }
            break;

        case ActivityResolution.InProgress:
            if (isSameOrganisation) {
                if ((isOwner || isAssignee) && userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivateNoteWithInProgressOption : ActivityActions.AddPrivateNoteWithNoInProgressOption);
                else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                if (userView.canCompleteActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CompletePublic : ActivityActions.CompletePrivate); }
                if (!userView.canAddPublicNotesActivity && !userView.canReassignActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithInProgressOption); }
            } else {
                if (isOwner) {
                    if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                    if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                } else if (isAssignee) {
                    if (userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                    if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignIntraOrganization); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                        actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                        actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivateNoteWithInProgressOption : ActivityActions.AddPrivateNoteWithNoInProgressOption);
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    if (userView.canCompleteActivity)
                        actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CompletePublic : ActivityActions.CompletePrivate);
                }
            }
            break;

        case ActivityResolution.ReAssigned:
            if (isSameOrganisation) {
                if (isOwner && userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithInProgressOption); }
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithInProgressOption); }
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
            } else {
                if (isOwner) {
                    if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                    if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                } else if (isAssignee) {
                    if (userView.canAcceptRejectActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.AcceptPublic : ActivityActions.AcceptPrivate); }
                    if (userView.canAcceptRejectActivity) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.RejectPublic : ActivityActions.RejectPrivate); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                }
            }
            break;

        case ActivityResolution.ReAssignedClosed:
            if (userView.canAddInternalNotesActivity)
                actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption);
            if (userView.canAddPersonalNotesActivity)
                actionList.push(ActivityActions.AddPersonalNote);
            break;

        case ActivityResolution.ReOpened:
            if (isSameOrganisation) {
                if ((isOwner || isAssignee) && userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivateNoteWithInProgressOption : ActivityActions.AddPrivateNoteWithNoInProgressOption);
                else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                    actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
            } else {
                if (isOwner) {
                    if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                    if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                    else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                    else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                        actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                    if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    if (userView.canChangeActivityOwner) { actionList.push(ActivityActions.ChangeActivityOwner); }
                    if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
                } else if (isAssignee) {
                    if (activityAssigneeId && activityAssigneeId > 0) {
                        if (userView.canMarkActivityAsInProgress) { actionList.push(ActivityActions.InProgress); }
                        if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignIntraOrganization); }
                        if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                            actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                        else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity)
                            actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivateNoteWithInProgressOption : ActivityActions.AddPrivateNoteWithNoInProgressOption);
                        else if (userView.canAddPublicNotesActivity && !userView.canAddInternalNotesActivity && !userView.canAddPersonalNotesActivity)
                            actionList.push(userView.canMarkActivityAsInProgress ? ActivityActions.AddPrivatePublicNoteWithInProgressOption : ActivityActions.AddPrivatePublicNoteWithNoInProgressOption);
                        if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    } else {
                        if (userView.canAcceptRejectActivity) {
                            if (!userView.canAddPublicNotesActivity) {
                                actionList.push(ActivityActions.AcceptPrivate);
                                actionList.push(ActivityActions.RejectPrivate);
                            } else {
                                actionList.push(ActivityActions.AcceptPublic);
                                actionList.push(ActivityActions.RejectPublic);
                            }
                        }
                        if (userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivatePublicNoteWithNoInProgressOption); }
                        else if (!userView.canAddPublicNotesActivity && userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                        if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                    }
                }
            }
            break;

        case ActivityResolution.Rejected:
            if (isOwner) {
                if (userView.canReassignActivity) { actionList.push(ActivityActions.ReassignInterIntraOrganization); }
                if ( userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
                if (userView.canCloseActivityduringMidterm) { actionList.push(userView.canAddPublicNotesActivity ? ActivityActions.CloseMidTermPublic : ActivityActions.CloseMidTermPrivate); }
            } else if (isAssignee) {
                if (userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
            }
            break;

        case ActivityResolution.RejectedClosed:
            if (!isSameOrganisation) {
                if (userView.canAddInternalNotesActivity) { actionList.push(ActivityActions.AddPrivateNoteWithNoInProgressOption); }
                if (userView.canAddPersonalNotesActivity) { actionList.push(ActivityActions.AddPersonalNote); }
            }
            break;
        default:
            break;
    }

    if (
        userView.canEditActivity &&
        //1st set
        (((canEditActivityTemplate) || isDefaultTemplate) && ownerOrgId === userOrgId)
        &&
        //2nd set
        (resolution !== ActivityResolution.ClosedMidTerm && resolution !== ActivityResolution.RejectedClosed &&
        resolution !== ActivityResolution.Closed && resolution !== ActivityResolution.ReAssignedClosed)
        ||
        //3rd set
        ((resolution === ActivityResolution.Accepted ||
        (resolution === ActivityResolution.ReOpened && activityAssigneeId) ||
        resolution === ActivityResolution.InProgress)
        && !isDefaultTemplate && userOrgId !== ownerOrgId && activityTemplateType === "CAT")
    ) {
        actionList.push(ActivityActions.EditActivity);
    }

    if (isOwner && userView.canCreateActivity) {
        actionList.push(ActivityActions.CloneActivity);
    }

    return actionList;
};
const ActivityActions = Object.freeze({
    ReassignInterIntraOrganization:0,
    AddPrivatePublicNoteWithInProgressOption:1,
    AddPrivatePublicNoteWithNoInProgressOption:2,
    AddPrivateNoteWithNoInProgressOption:3,
    AddPrivateNoteWithInProgressOption:4,
    AddPersonalNote:5,
    CloseMidTermPublic:6,
    CloseMidTermPrivate:7,
    ChangeActivityOwner:8,
    InProgress:9,
    ReOpenPrivate:10,
    ReOpenPublic:11,
    CompletePublic:12,
    CompletePrivate:13,
    AcceptPrivate:14,
    AcceptPublic:15,
    RejectPublic:16,
    RejectPrivate:17,
    ReassignIntraOrganization:18,
    ClosePrivate:19,
    ClosePublic:20,
    EditActivity:21,
    CloneActivity:22,
    CreateActivity:23,
    ChangeDueDate:24,
    AddPublicNote:25,
    AddPrivateNote:26,
    CloseMidTerm:27,
    ReOpen:28,
    Complete:29,
    Accept:30,
    Reject:31,
    Close:32,
    ReassignToTeamMember:33,
    ReassignToB2B:34
});

const WorkkardActionsMenu = Object.freeze({
  CreateActivity: 0,
  CreateBidActivity: 1,
  ChangeWorkkardSponsor: 2,
  LinkCompanionWorkkard: 3,
  AddPersonalNotes: 4,
  AddPrivateNotes: 5,
  AddPublicNotes: 6,
  EditWorkkard: 7,
  CloseWorkkard: 8,
  CreateRequestLetter: 9,
  ContactEnsured: 10,
  CanReopenWorkkard: 11,
  ShareProposal: 12,
});

export function GetWorkkardActionsMenuList(
  uview,
  userOrgId,
  sponsorOrgId,
  isWorkkardOpen,
  isClaimWorkkard
  ) {
  const actionMenu = [];
  const belongsToSponsorOrg = userOrgId === sponsorOrgId;

  if (uview.canCreateActivity) {
    actionMenu.push(WorkkardActionsMenu.CreateActivity);
  }

  if (uview.canAddPersonalNotesWorkkard && belongsToSponsorOrg) {
    actionMenu.push(WorkkardActionsMenu.AddPersonalNotes);
  }

  if (uview.canAddPublicNotesWorkkard && belongsToSponsorOrg) {
    actionMenu.push(WorkkardActionsMenu.AddPublicNotes);
  }

  if (uview.canAddPrivateNotesWorkkard && belongsToSponsorOrg) {
    actionMenu.push(WorkkardActionsMenu.AddPrivateNotes);
  }

  if (uview.canCloseWorkkard && isWorkkardOpen) {
    actionMenu.push(WorkkardActionsMenu.CloseWorkkard);
  }

  if (uview.canReopenWorkkard && !isWorkkardOpen) {
    actionMenu.push(WorkkardActionsMenu.CanReopenWorkkard);
  }

  if (
    uview.canChangeWorkkardSponsor &&
    belongsToSponsorOrg &&
    isWorkkardOpen
  ) {
    actionMenu.push(WorkkardActionsMenu.ChangeWorkkardSponsor);
  }

  if (
    belongsToSponsorOrg &&
    (
      (isWorkkardOpen && uview.canEditWorkkard) ||
      (!isWorkkardOpen && uview.canEditClosedWorkkard)
    )
  ) {
    actionMenu.push(WorkkardActionsMenu.EditWorkkard);
  }

  if (uview.canRequestForLetter) {
    actionMenu.push(WorkkardActionsMenu.CreateRequestLetter);
  }

  if (
    process.env.ContactInsuredEnable == true &&
    useModules().isModuleEnabled("contact_insured") &&
    isClaimWorkkard &&
    isWorkkardOpen &&
    belongsToSponsorOrg
  ) {
    actionMenu.push(WorkkardActionsMenu.ContactEnsured);
  }

  if (uview.canShareProposal && !isWorkkardOpen) {
    actionMenu.push(WorkkardActionsMenu.ShareProposal);
  }

  return actionMenu;
}